'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMCSLinkByLocale = exports.localeMapper = exports.LOCALES = undefined;

var _equals2 = require('ramda/src/equals');

var _equals3 = _interopRequireDefault(_equals2);

var _T2 = require('ramda/src/T');

var _T3 = _interopRequireDefault(_T2);

var _always2 = require('ramda/src/always');

var _always3 = _interopRequireDefault(_always2);

var _test2 = require('ramda/src/test');

var _test3 = _interopRequireDefault(_test2);

var _cond2 = require('ramda/src/cond');

var _cond3 = _interopRequireDefault(_cond2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOCALES = exports.LOCALES = [{
  id: 'en',
  children: 'English'
}, {
  id: 'zh-TW',
  children: '繁體中文'
}, {
  id: 'zh-CN',
  children: '简体中文'
}];

var localeMapper = exports.localeMapper = function localeMapper(defaultLocale) {
  return function (locale) {
    return (0, _cond3.default)([[(0, _test3.default)(/^en/gi), (0, _always3.default)('en')], [(0, _test3.default)(/^zh-TW/gi), (0, _always3.default)('zh-TW')], [(0, _test3.default)(/^zh-CN/gi), (0, _always3.default)('zh-CN')], [(0, _test3.default)(/^zh/gi), (0, _always3.default)('zh-TW')], [_T3.default, (0, _always3.default)(defaultLocale)]])(locale);
  };
};

var getMCSLinkByLocale = exports.getMCSLinkByLocale = function getMCSLinkByLocale(locale) {
  return (0, _cond3.default)([[(0, _equals3.default)('en'), (0, _always3.default)('https://mcs.mediatek.com/')], [(0, _equals3.default)('zh-CN'), (0, _always3.default)('https://mcs.mediatek.cn/')], [_T3.default, function (l) {
    return 'https://mcs.mediatek.com/' + l + '/';
  }]])(locale);
};


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-ui/lib/utils/localeHelper.js
// module id = 92
// module chunks = 4